// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"803587df","453":"19de06ab"}[chunkId] + ".chunk.js";
};